export const cardStyle = ({ palette = {} }) => ({
  border: `1px solid ${palette.neutralLighter}`,
  fontSize: 14,
  marginBottom: 32,
  width: '100%',

  '& .qi-card-content': {
    position: 'relative',
    padding: '12px 16px 16px 16px',

    '& .qi-card-title': {
      fontSize: 16,
      fontWeight: 600,
    },

    '& .qi-card-description': {
      color: palette.neutralSecondary,
      padding: '12px 0',
    },

    '& .qi-card-feedback': {
      position: 'absolute',
      right: 16,
      top: 12,
    },
  },
});
